// เครดิตกระสอบ — ฟังก์ชันล้วนของหน้า (ไม่แตะ API) · ลบ = ขาด, บวก = เกิน
// tube = เชือกเขียว (หลอดใหญ่) · crushed = เชือกแดง (บด)

export const ZERO = { tube: 0, crushed: 0 };

export const qtyOf = (q) => ({ tube: Number(q?.tube) || 0, crushed: Number(q?.crushed) || 0 });

export const isZero = (q) => qtyOf(q).tube === 0 && qtyOf(q).crushed === 0;

// ยอดคงเหลือ = ยอดยกมา + Σ ขาด/เกินรายรอบ + Σ ที่ปิดแล้ว (ปิด = จำนวนกระสอบขาดที่ปิด เป็นบวก)
export const balanceOf = ({ opening, variance, closed }) => {
    const o = qtyOf(opening), v = qtyOf(variance), c = qtyOf(closed);
    return { tube: o.tube + v.tube + c.tube, crushed: o.crushed + v.crushed + c.crushed };
};

// จำนวนที่ "ปิดเต็ม" ได้ = ส่วนที่ขาดอยู่ของแต่ละชนิด (ยอดเกินปิดไม่ได้ ได้ 0)
export const fullCloseQty = (balance) => {
    const b = qtyOf(balance);
    return { tube: Math.max(0, -b.tube), crushed: Math.max(0, -b.crushed) };
};

export const signed = (n) => (n > 0 ? `+${n}` : String(n));

export const tone = (n) => (n < 0 ? '#c0392b' : n > 0 ? '#1e8449' : '#6c757d');

// ผสมรายชื่อทะเบียนคนขับ (seller) กับแถวสรุป (saledata) — ทุกคนในทะเบียนมีแถว เริ่มที่ 0
// ชื่อ: ทะเบียนก่อน (ชื่อเล่นล่าสุด) แล้วค่อยชื่อที่บันทึกไว้กับรายการ · ไม่โชว์ uid ถ้าไม่มีชื่อ
export const mergeDrivers = (registry, summaryRows) => {
    const rows = new Map();
    (summaryRows || []).forEach(r => rows.set(r.driverUid, { ...r }));
    (registry || []).forEach(d => {
        const uid = d.employeeUid;
        if (!uid) return;
        const base = rows.get(uid) || {
            driverUid: uid, opening: ZERO, variance: ZERO, closed: ZERO, balance: ZERO,
        };
        rows.set(uid, { ...base, driverName: d.nickname || base.driverName, registered: true });
    });
    return Array.from(rows.values())
        .map(r => ({ ...r, driverName: r.driverName || 'ไม่ทราบชื่อ' }))
        .sort((a, b) => a.driverName.localeCompare(b.driverName, 'th'));
};

// ตรวจฟอร์มปิดยอดก่อนยิง (server ตรวจซ้ำ)
export const validateSettlement = (form, balance) => {
    const tube = Number(form.tubeQty) || 0;
    const crushed = Number(form.crushedQty) || 0;
    const max = fullCloseQty(balance);
    if (!Number.isInteger(tube) || !Number.isInteger(crushed) || tube < 0 || crushed < 0) return 'จำนวนกระสอบต้องเป็นจำนวนเต็มไม่ติดลบ';
    if (tube === 0 && crushed === 0) return 'กรอกจำนวนกระสอบที่ปิดอย่างน้อย 1 ชนิด';
    if (tube > max.tube) return `ปิดเชือกเขียวได้ไม่เกิน ${max.tube}`;
    if (crushed > max.crushed) return `ปิดเชือกแดงได้ไม่เกิน ${max.crushed}`;
    if (form.cashAmount !== '' && form.cashAmount != null && !(Number(form.cashAmount) >= 0)) return 'เงินสดที่รับต้องไม่ติดลบ';
    return '';
};

export const validateAdjustment = (form) => {
    const tube = Number(form.tubeQty) || 0;
    const crushed = Number(form.crushedQty) || 0;
    if (!Number.isInteger(tube) || !Number.isInteger(crushed)) return 'จำนวนกระสอบต้องเป็นจำนวนเต็ม';
    if (tube === 0 && crushed === 0) return 'กรอกจำนวนกระสอบอย่างน้อย 1 ชนิด (ลบ = ขาด, บวก = เกิน)';
    if (!String(form.note || '').trim()) return 'ต้องใส่หมายเหตุ';
    return '';
};
